import React from 'react';
import styled, { css } from 'styled-components';

import icons from './svg';

const Wrapper = styled.div`
    height: ${p => p.size};
    width: ${p => p.size};
    ${p => !p.$noFill && css`
        & > svg path,
        & > svg rect,
        & > svg circle,
        & > svg ellipse,
        & > svg polygon {
            fill: ${p.fillColor || p.theme.text};
        }
    `}
`;

export const Icon = ({
    type,
    color,
    size = '32px',
    noFill,
    ...props
}) => {
    if (!icons.has(type)) {
        return null;
    }

    const IconSvg = icons.get(type);

    return (
        <Wrapper
            $noFill={noFill}
            fillColor={color}
            size={size}
            {...props}
        >
            <IconSvg />
        </Wrapper>
    );
};
